export default __webpack_public_path__ + "static/media/whiteTick.e924c8d9.svg";